import React from "react";
import { CoRetrieveDocumentId } from "../../components/generic/CoRetrieveDocumentId";
import { ObjectPanelElaborationWrapper } from "../../components/coobjects/ObjectPanelElaborationWrapper";
import { DocumentNotValidError } from "../../components/generic/DocumentNotValidError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";

export const NewObjectPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent
      userFunction={UserFunctionEnum.MENU_NEW_OBJECT}
      protectionType={true}
      errorComponent={<UnauthorizedError />}
    >
      <CoRetrieveDocumentId>
        {(coObject) =>
          coObject && coObject.documentId ? (
            <ObjectPanelElaborationWrapper isEdit={false} coObject={coObject} />
          ) : (
            <DocumentNotValidError />
          )
        }
      </CoRetrieveDocumentId>
    </ProtectedComponent>
  );
};
